export const actions = {
  updateConfig({ commit }, { capNewConfigId, payload }) {
    let url = capNewConfigId
      ? `/data_api/new/capConfig/update/${capNewConfigId}`
      : '/data_api/new/capConfig/update'
    
    return this.$axios.patch(url, payload)
  }
}
